var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ComposerContext, GlobalContext, ComposerContextAction, useGlobalValue, useInitComposerValue, GlobalContextAction } from './lib/internals/state';
import { useMessages } from './utils/chat';
function MessageCanvas(_a) {
    var children = _a.children;
    // const [keys] = useAtom(rMessageIds)
    var keys = useMessages(function (state) { return Object.keys(state).map(function (n) { return parseInt(n); }); });
    return (React.createElement(React.Fragment, null, keys.map(function (messageId) { return (children({ messageId: messageId, key: "message-id-" + messageId })); })));
}
function ComposerProvider(_a) {
    var composerOptions = _a.composerOptions, initialComposer = _a.initialComposer, children = _a.children;
    // const [composerOpts, ] = useState<Potato.Composer.GlobalContext<TComposerType, TMessageInputType>>(composerConfig)
    var initComposerConfig = {
        composerType: initialComposer,
        composerOptions: composerOptions
    };
    var _b = useInitComposerValue(initComposerConfig), composerGlobalState = _b[0], composerDispatch = _b[1];
    return (
    // @ts-ignore
    React.createElement(ComposerContext.Provider, { value: composerGlobalState },
        React.createElement(ComposerContextAction.Provider, { value: composerDispatch }, children)));
}
var GlobalContextProvider = function (_a) {
    var children = _a.children, initialMessages = _a.initialMessages, globalChatContext = _a.globalChatContext;
    var initialState = __assign(__assign({}, globalChatContext), { messages: (initialMessages || []) });
    var _b = useGlobalValue(initialState), globalVals = _b[0], globalDispatch = _b[1];
    return (React.createElement(GlobalContext.Provider, { value: globalVals },
        React.createElement(GlobalContextAction.Provider, { value: globalDispatch }, children)));
};
export function PotatoChatProvider(_a) {
    var children = _a.children, initialMessages = _a.initialMessages, globalChatContext = _a.globalChatContext;
    return (React.createElement(GlobalContextProvider, { initialMessages: initialMessages, globalChatContext: globalChatContext }, children));
}
/**
 * Provider to provide the chat ui with state to manage
 * chat context
 */
export function PotatoChat(_a) {
    var composerOptions = _a.composerOptions, sendAction = _a.sendAction, initialComposer = _a.initialComposer, MessageComponent = _a.messageComponent, MessageCanvasWrapper = _a.messageCanvasWrapper, ComposerBox = _a.composerBox;
    // console.log("Initialized Globasl State: ", globalChatContext)
    return (React.createElement(React.Fragment, null,
        React.createElement(MessageCanvasWrapper, null,
            React.createElement(MessageCanvas, null, function (messageProps) { return React.createElement(MessageComponent, __assign({}, messageProps)); })),
        React.createElement(ComposerProvider, { initialComposer: initialComposer, composerOptions: composerOptions },
            React.createElement(ComposerBox, { sendAction: sendAction }))));
}
